import React, { useContext } from 'react';
import { DraggableItemData } from '../../../../../Common/DraggableItem';
import { CustomFieldContext } from '../../../../../../../context/CustomFieldContext';
import {
  ProductExportConfiguration,
  ProductExportConfigurationField,
} from '../../../../../../../types/product_export_configuration/productExportConfiguration';
import { CustomFieldEntityType } from '../../../../../../../types/custom_field';
import NotFound from '../../../../../../components/NotFound/NotFound';
import ExportConfigurationForm, {
  DraggableExportFieldIdentifier,
} from '../../../../../../components/Export/ExportConfigurationForm';
import { ProductExportConfigurationInput } from '../../../../../../../types/product_export_configuration';
import { translate } from '../../../../../../../types/translation/Translator';

interface ProductExportConfigurationMapping {
  value: string;
  index: number;
  field: ProductExportConfigurationField;
}

export interface DraggableProductExportFieldIdentifier
  extends DraggableExportFieldIdentifier<ProductExportConfigurationField>,
    ProductExportConfigurationMapping {}

interface ProductExportConfigurationFormProps {
  input: ProductExportConfigurationInput;
  setInput: React.Dispatch<React.SetStateAction<ProductExportConfigurationInput>>;
  footer: (
    configuration: ProductExportConfigurationInput,
    items: DraggableProductExportFieldIdentifier[],
  ) => JSX.Element;
  loading?: boolean;
}

export default function ProductExportConfigurationForm({
  input,
  setInput,
  footer,
  loading = false,
}: ProductExportConfigurationFormProps) {
  if (!input) return <NotFound />;

  const { customFields } = useContext(CustomFieldContext);

  const draggableItems: DraggableProductExportFieldIdentifier[] =
    DraggableItemData.forExportConfiguration<ProductExportConfigurationField>([
      ...Object.values(ProductExportConfigurationField).map(field => ({
        field,
        label: translate({ key: field }),
      })),
      ...[...customFields.values()]
        .filter(
          item =>
            item.entityType === CustomFieldEntityType.productMasterData ||
            item.entityType === CustomFieldEntityType.product ||
            item.entityType === CustomFieldEntityType.lot ||
            item.entityType == CustomFieldEntityType.bin ||
            item.entityType === CustomFieldEntityType.container,
        )
        .map(item => ({ field: item.id, label: item.name })),
    ]);

  return (
    <ExportConfigurationForm
      placeholder={'Add product export field'}
      loading={loading}
      input={input}
      setInput={setInput}
      footer={footer}
      draggableItems={draggableItems}
      toDraggableItems={ProductExportConfiguration.toDraggableItems}
    />
  );
}
